import { queryOptions, skipToken } from "@tanstack/react-query";

import { MASTER_INVALIDATION_KEY } from "@/api/queryClient";
import {
  getDeviceModelFile,
  getDeviceModelFilesById,
  getPaginatedWorkspaceDeviceModelFiles,
  getWorkspaceDeviceModelFiles,
} from "@/api/resources/deviceModelFiles/api";
import i18n from "@/providers/i18n";

import type { GetPaginatedWorkspaceDeviceModelFilesProps } from "@/api/resources/deviceModelFiles/types";

const entity = i18n.t("file");
const entityErrorMessage = {
  text: i18n.t("notify.error-reason.unexpected"),
  title: i18n.t("notify.get.error", { e: entity }),
};
const entities = i18n.t("files");
const entitiesErrorMessage = {
  text: i18n.t("notify.error-reason.unexpected"),
  title: i18n.t("notify.get.error", { e: entities }),
};

export const deviceModelFilesQueryKeys = {
  all: () => [...MASTER_INVALIDATION_KEY, "deviceModelFiles"],
  lists: () => [...deviceModelFilesQueryKeys.all(), "list"],
  listbyWorkspace: (workspace_id?: string) => [...deviceModelFilesQueryKeys.lists(), "listByWorkspace", workspace_id],
  listPaginatedByWorkspace: (queryKeyPaginationFilters: GetPaginatedWorkspaceDeviceModelFilesProps) => [
    ...deviceModelFilesQueryKeys.lists(),
    "paginatedByWorkspace",
    queryKeyPaginationFilters,
  ],
  listById: (device_model_id?: string) => [...deviceModelFilesQueryKeys.lists(), "listById", device_model_id],
  byId: (id?: string) => [...deviceModelFilesQueryKeys.all(), "byId", id],
};

export const deviceModelFilesQueries = {
  listbyWorkspace: (workspace_id?: string) =>
    queryOptions({
      queryKey: [...deviceModelFilesQueryKeys.listbyWorkspace(workspace_id)],
      queryFn: workspace_id ? () => getWorkspaceDeviceModelFiles(workspace_id) : skipToken,
      meta: {
        errorMessage: entitiesErrorMessage,
      },
    }),
  listPaginatedByWorkspace: (queryKeyPaginationFilters: GetPaginatedWorkspaceDeviceModelFilesProps) =>
    queryOptions({
      queryKey: [...deviceModelFilesQueryKeys.listPaginatedByWorkspace(queryKeyPaginationFilters)],
      queryFn: () => getPaginatedWorkspaceDeviceModelFiles(queryKeyPaginationFilters),

      meta: {
        errorMessage: entitiesErrorMessage,
      },
    }),
  listById: (device_model_id?: string) =>
    queryOptions({
      queryKey: [...deviceModelFilesQueryKeys.listById(device_model_id)],
      queryFn: device_model_id ? () => getDeviceModelFilesById(device_model_id) : skipToken,

      meta: {
        errorMessage: entitiesErrorMessage,
      },
    }),
  byId: (id?: string) =>
    queryOptions({
      queryKey: [...deviceModelFilesQueryKeys.byId(id)],
      queryFn: id ? () => getDeviceModelFile({ match: { id } }) : skipToken,

      meta: {
        errorMessage: entityErrorMessage,
      },
    }),
};
